import React, { useEffect, useState } from 'react';
import './Contact.css'; // Updated external CSS file for styling
import Footer from '../../Components/Footer/Footer';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';

const ContactUsPage = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <>
            <HomeNav />
            <div className="contact-wrapper">
                <div className="contact-box">
                    <h2 className="contact-heading">Contact Us</h2>
                    <form className="contact-form-content">
                        <div className="input-group">
                            <label>Full Name</label>
                            <input type="text" className="form-input" placeholder="Enter your full name" />
                        </div>
                        <div className="input-group">
                            <label>Email Address</label>
                            <input type="email" className="form-input" placeholder="Enter your email address" />
                        </div>
                        <div className="input-group">
                            <label>Enter Phone Number</label>
                            <div className="phone-box">
                                <select className="phone-code">
                                    <option value="+91">+91</option>
                                </select>
                                <input type="tel" className="form-input" placeholder="Enter your phone number" />
                            </div>
                        </div>
                        <div className="input-group">
                            <label>Enter Message</label>
                            <textarea className="form-textarea" placeholder="Type your message..."></textarea>
                        </div>
                        <button type="submit" className="submit-button">Submit</button>
                    </form>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ContactUsPage;
